import { Eye, Users, Mail, Bell } from "lucide-react";

export default function NewsletterRow({ newsletter, onView }) {
  const admin = newsletter.admin;
  
  return (
    <tr>
      <td>
        <div className="userCell">
          <div className="userName">{newsletter.title}</div>
        </div>
      </td>

      <td>
        <div className="destBadge">
           <Users size={14} /> {newsletter.sent_to_count} utilisateurs
        </div>
      </td>

      <td className="descriptionCell">
        {newsletter.content.substring(0, 50)}...
      </td>

      <td className="center">
        <div className="actions">
          <button className="iconBtn" onClick={() => onView(newsletter)}>
            <Eye size={18} />
          </button>
        </div>
      </td>
    </tr>
  );
}